import {ComponentProps} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {CloseIconButton} from "../../../atoms/CloseIconButton";
import {UnifiedLeadForm} from "./UnifiedLeadForm";

type IUnifiedLeadFormProps = ComponentProps<typeof UnifiedLeadForm>;

type IProps = Omit<IUnifiedLeadFormProps, "customHeader">;

export const LeadModalUnifiedForm = (props: IProps) => {
    const {handleModalClose} = props;

    return (
        <div className={containerStyles}>
            <div className={innerContainerStyles} data-testid={OFFER_TEST_IDS.OFFER_VIEW.LEAD_FORM_MODAL}>
                <CloseIconButton className={closeButtonStyles} onClick={handleModalClose} size="1.6" />

                <UnifiedLeadForm
                    {...props}
                    customHeader={
                        <Text variant="headline_4" as="p" mb={3} className={titleStyle}>
                            Zapytaj dewelopera o pełną ofertę
                        </Text>
                    }
                />
            </div>
        </div>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "556px",
        h: "auto",
        overflow: "visible"
    }
});

const innerContainerStyles = css({
    p: 3
});

const titleStyle = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});
import {ComponentProps} from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {CloseIconButton} from "../../../atoms/CloseIconButton";
import {UnifiedLeadForm} from "./UnifiedLeadForm";

type IUnifiedLeadFormProps = ComponentProps<typeof UnifiedLeadForm>;

type IProps = Omit<IUnifiedLeadFormProps, "customHeader">;

export const LeadModalUnifiedForm = (props: IProps) => {
    const {handleModalClose} = props;

    return (
        <div className={containerStyles}>
            <div className={innerContainerStyles} data-testid={OFFER_TEST_IDS.OFFER_VIEW.LEAD_FORM_MODAL}>
                <CloseIconButton className={closeButtonStyles} onClick={handleModalClose} size="1.6" />

                <UnifiedLeadForm
                    {...props}
                    customHeader={
                        <Text variant="headline_4" as="p" mb={3} className={titleStyle}>
                            Zapytaj dewelopera o pełną ofertę
                        </Text>
                    }
                />
            </div>
        </div>
    );
};

const containerStyles = css({
    w: "100%",
    h: "100%",
    overflowY: "auto",
    md: {
        maxW: "556px",
        h: "auto",
        overflow: "visible"
    }
});

const innerContainerStyles = css({
    p: 3
});

const titleStyle = css({
    textAlign: "left",
    pr: 4,
    md: {
        textAlign: "center"
    }
});

const closeButtonStyles = css({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    boxShadow: "var(--shadow-2)",
    background: "white",
    width: "3.2rem",
    height: "3.2rem",
    zIndex: 11
});
